import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from "../Navigation/Navigation";
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import MonitoringKontingentDto from "./MonitoringKontingentDto";
import KontingentMonitoringService from "../../services/KontingentMonitoringService";

import './KontingentMonitoringUebersicht'
import './KontingentMonitoringWeitergabe'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation'

export default class KontingentMonitoring extends WebComponent {

  constructor() {
    super()
    this.kontingentMonitoringService = new KontingentMonitoringService()
  }

  get translationFile() {
    return './views/KontingentMonitoring/i18n.json'
  }

  get subsites() {
    return {
      Kontingent: {
        render: () => html`
          <eko-frontend-kontingent-monitoring-uebersicht .kontingent="${this.kontingent}"></eko-frontend-kontingent-monitoring-uebersicht>
        `
      },
      KontingentWeitergabe: {
        render: () => html`
          <eko-frontend-kontingent-monitoring-weitergabe .kontingent="${this.kontingent}"></eko-frontend-kontingent-monitoring-weitergabe>
        `
      }
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.kontingentMonitoringService.read(getNavigationId())
    ).then(kontingent => {
      this.kontingent = new MonitoringKontingentDto(kontingent)
      this.render()
    })
  }

  getTemplate() {
    if (this.kontingent === undefined) {
      return html`
        <isceco-title id="page-title" text="${this.i18n.translate('kontingentMonitoring.verordnung.empty')}">
        </isceco-title>
      `
    }

    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('kontingentMonitoring.verordnung.title',
        {srNummer: this.kontingent.srNummer, von: formatDate(this.kontingent.periodeStart), bis: formatDate(this.kontingent.periodeEnde)})}">
      </isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
    `
  }

  _getNavItems = () => {
    const roles = new AuthorizationFilter().roles
    return [
      {
        text: this.i18n.translate('kontingentMonitoring.back'),
        icon: 'long arrow alternate left',
        url: `${Navigation.ROUTES.monitoringVerordnung.url}/${this.kontingent.verordnungId}`,
        roles: [true]
      },
      {
        text: this.i18n.translate('kontingentMonitoring.uebersicht.title'),
        icon: 'stream',
        url: `${Navigation.ROUTES.monitoringKontingent.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.monitoringKontingent.url],
        roles: [roles.GP]
      },
      {
        text: this.i18n.translate('kontingentMonitoring.weitergabe.title'),
        icon: 'exchange alternate',
        url: `${Navigation.ROUTES.kontingentWeitergabe.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.kontingentWeitergabe.url],
        roles: [roles.GP]
      }
    ].filter(i => i.roles.some(r => r))
  }
}

customElements.define('eko-frontend-kontingent-monitoring', KontingentMonitoring)
